<script type="text/jsx">
    import Vue from 'vue'
    export default {
        computed : {
            isGc: function () {
                return false;
            }
        },
        methods: {
            validateProductProperties: function () {
                // currently assuming that a brick has a location or a logo, but not both simultaneously
                return new Promise((resolve, reject) => {
                    resolve();
                });
            },
            is4x8: function (itemImageBlank) {
                return itemImageBlank.indexOf('4x8') !== -1;
			},
			is12x12: function (itemImageDefault) {
                return itemImageDefault.indexOf('12x12') !== -1;
			},
			isTree: function (itemImageDefault) {
                return itemImageDefault.indexOf('tree') !== -1;
            },
			isNook: function (itemImageDefault) {
                return itemImageDefault.indexOf('nook') !== -1;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// product-handling.vue?30b7f7e8